import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import { browserHistory } from 'react-router';
import BillListFilterContainer from './BillListFilterContainer';
import BillListContainer from './BillListContainer';
import BillPaymentDialogContainer from './BillPaymentDialogContainer';
import PermissionValidator from '../../../core/layout/PermissionValidator';
import PropTypes from 'prop-types';
import BillCancellationDialogContainer from './BillCancellationDialogContainer';

const BillListScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location && props.location.documentNumber ? [{ text: 'Contract', link: '/contracts' }] : []),
        { text: 'Billing' },
      ]}
    />
    <Card
      title="Billing"
      actions={
        <PermissionValidator allowedFor={['ADMIN', 'SUPPORT']}>
          <Button
            type="primary"
            icon="plus"
            label="New Bill"
            onClick={() =>
              browserHistory.push({
                pathname: `/billing/new`,
                state: { from: { text: 'Billing', pathname: '/billing' } },
              })
            }
          />
        </PermissionValidator>
      }
    >
      <BillListFilterContainer initialFilters={props.location} />
      <BillListContainer />
      <BillPaymentDialogContainer />
      <BillCancellationDialogContainer />
    </Card>
  </>
);

BillListScene.propTypes = {
  location: PropTypes.object,
};

export default BillListScene;
